export default __webpack_public_path__ + "static/media/No48.ca0c8e9c.png";